var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('xes-center-navigator',{attrs:{"activeIndex":4,"domain":"ocenter","fixed":""}}),_vm._v(" "),_c('xes-mall-sidebar',{attrs:{"qiyuParams":_vm.qiyuParams,"sideList":_vm.SIDE_BAR_DATA}}),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('xDialog')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ebbcd362","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./module/order/src/App.vue
// module id = null
// module chunks = 